import { useCallback, useEffect, useState } from "react";
import { api } from "./apiClient";

export function useDashboard() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const load = useCallback(() => {
    return api.get("/dashboard")
      .then((r) => setData(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);
  useEffect(() => {
    load();
    const onFocus = () => document.visibilityState === "visible" && load();
    document.addEventListener("visibilitychange", onFocus);
    return () => document.removeEventListener("visibilitychange", onFocus);
  }, [load]);
  return { data, loading, reload: load };
}

export const StatCard = ({ icon: Icon, label, value, color = "#4A6B53", testid, onClick }) => (
  <button type="button" data-testid={testid} onClick={onClick}
    className={`text-left bg-white border border-[#E2DFD8] rounded-2xl p-5 shadow-sm transition-colors ${onClick ? "hover:border-[#4A6B53]" : "cursor-default"}`}>
    <div className="flex items-center gap-2 mb-2">
      <Icon className="w-4 h-4" strokeWidth={1.5} style={{ color }} />
      <p className="text-[10px] font-bold text-[#7A8C82] uppercase tracking-wider">{label}</p>
    </div>
    <p className="font-display text-4xl font-extrabold" style={{ color }}>{value}</p>
  </button>
);
